import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {usersColumns, usersColumns_admin, usersColumns_visitor} from './columns/_columns'
import {LanguageModel} from '../core/_models'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'

type Props = {
  userType: string
}

const UsersTable: React.FC<Props> = ({userType}) => {
  const users = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => users, [users])
  const columns = useMemo(
    () =>
      userType == 'USER'
        ? usersColumns
        : userType == 'VISITOR'
        ? usersColumns_visitor
        : usersColumns_admin,
    []
  )
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table table-row-dashed table-row-gray-100 align-middle gs-2 gy-2 table-hover'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-semibold fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<LanguageModel>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='table-hover' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<LanguageModel>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={row.id} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                    <div className='text-center'>
                      <div className='symbol symbol-200px '>
                        <img src='/media/other/nodata.png' alt='' />
                      </div>
                    </div>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                      No matching records found
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <UsersListPagination />
      {isLoading && <UsersListLoading />}
    </KTCardBody>
  )
}

export {UsersTable}
